<template>
  <section class="max-w-3xl mx-auto px-4 py-10 space-y-8">
    <header class="space-y-2">
      <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-gray-100">Terms &amp; Conditions</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">Last updated: February 12, 2026</p>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        By using
        <a href="https://rozay.today" class="underline hover:no-underline dark:text-gray-200">rozay.today</a>, you agree to these Terms
        &amp; Conditions.
      </p>
    </header>

    <div class="space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-6">
      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">1. Informational Use Only</h2>
        <p>
          Rozay provides Islamic and Ramadan-related information, including Sehri and Iftar timings, Ramadan calendar
          details, Roza rules, Duas, Fitrana guidance, and Lailat-ul-Qadr content.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">2. Timing Accuracy</h2>
        <p>
          We try to provide accurate timings, but slight differences can occur due to local mosque methods, fiqh
          preferences, or moon sighting decisions. Please follow your local mosque or scholar where needed.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">3. No Religious Verdicts</h2>
        <p>
          The content is general guidance and does not replace personal advice from qualified scholars for specific
          religious matters.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">4. Website Availability</h2>
        <p>
          We may update, pause, or change features at any time. We do not guarantee uninterrupted access to the
          website.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">5. Third-Party Services</h2>
        <p>
          The website may use third-party tools like Google Analytics and may use Google AdSense in the future. These
          services have their own terms and privacy policies.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">6. Limitation of Liability</h2>
        <p>
          Rozay and its team are not responsible for losses or decisions made only on the basis of website content.
          Always verify important religious timings and rulings from trusted local sources.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">7. Changes to These Terms</h2>
        <p>We may update these terms from time to time. Continued use of the website means you accept any updates.</p>
      </section>
    </div>
  </section>
</template>
